import Error from '../model/Error';
import PossibleStatusTransition from '../dto/PossibleStatusTransition';
import axios from 'axios';

export default class PossibleStatusTransitionRepository {
    static findForChild(childId) {
        return new Promise((resolve, reject) => {
            axios
                .get('/children/' + childId + '/possible-status-transitions')
                .then(response => resolve(response.data.data.map(data => PossibleStatusTransition.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
